import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EChartsOption } from 'echarts';
import { NgxEchartsModule } from 'ngx-echarts';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-line-chart',
  standalone: true,
  imports: [NgxEchartsModule],
  template: `
    <div class="flex w-full h-full ">
      <div echarts 
           [options]="lineChartOptions" 
           [style.width]="'100%'"
           [style.height]="height + 'px'"
           class="w-full h-full">
      </div>
    </div>
  `,
  styles: ``
})
export class LineChartComponent implements OnChanges {
  @Input() data$: Observable<any[]> = of([]);
  @Input() height: number = 200;  // Changed to pixels for consistency
  @Input() chartlabel: boolean = true;
  @Input() xAxisLabel: boolean = true;
  @Input() yAxisLabel: boolean = true;

  lineChartOptions: EChartsOption = {};

  ngOnChanges(changes: SimpleChanges) {
    this.updateChartOptions();
  }

  updateChartOptions() {
    this.lineChartOptions = {
      tooltip: { trigger: 'axis' },
      legend: { show: this.chartlabel },
      grid: {
        left: '3%',
        right: '3%',
        top: '10%',
        bottom: '10%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        axisLabel: { fontSize: 12,show: this.xAxisLabel },
        boundaryGap: false
      },
      yAxis: { 
        type: 'value',
        axisLabel: { show: this.yAxisLabel },  // Show Y-axis labels
        splitLine: { show: true } 
      },
      series: [
        {
          name: 'Sales',
          type: 'line',
          data: [50, 80, 60, 90, 70, 100],
          smooth: true,
          itemStyle: { color: '#2C4F94' },
          lineStyle: { width: 3 },  // Slightly thicker line
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: 'rgba(44, 79, 148, 0.6)' },
                { offset: 1, color: 'rgba(44, 79, 148, 0)' }
              ]
            }
          }
        },
        {
          name: 'Revenue',
          type: 'line',
          data: [45, 75, 55, 85, 65, 95],
          smooth: true,
          itemStyle: { color: '#E74C5E' },
          lineStyle: { width: 3 },  // Slightly thicker line
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: 'rgba(231, 76, 94, 0.6)' },
                { offset: 1, color: 'rgba(231, 76, 94, 0)' }
              ]
            }
          }
        }
      ]
    };
  }
}